define.alias("shared/components/shared/image", "settings/components/shared/image");